module.exports = __webpack_public_path__ + "img/car2.02240970.png";